import { ThemeData } from '../lib/interface';

export const getThemeData = (theme: string) => {;
  const darkMode = (true ? theme === 'dark' : false);
  const themeData: ThemeData = {
    // arbitrage page
    ARBbgGlobal: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#070816"
      : "#ffffff",
    ARBbgBox: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#12121c"  //"linear-gradient(150deg, #12121c 0%, #1f2b35 50%, #343e4f 100%)"
      : "#ffffff", //"linear-gradient(150deg, #fafafa 0%, #e0e4e8 50%, #c8d1d8 100%)",
    ARBbgBoxAlt1: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#282c36"
      : "#eff3fb",
    ARBbgBoxHeader: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#8089a1"
      : "#638ad9",
    ARBborderBox: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#343e4f"
      : "#c8d1d8",
    ARBtextColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "white"
      : "black",
    ARBtextColor2: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "grey"
      : "grey",
    ARBtextColor3: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "lightblue"
      : "black",
    ARBtextColorLink: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#25adea"
      : "#3C84E4",
    ARBiconColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "lightblue"
      : "black",
    ARBtitleColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#3399cc"
      : "#0073a8",
    ARBbuttonColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#12121c"  //"linear-gradient(to right, #25adea 0%, #a151ff 100%)"
      : "#ffffff", //"linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
    ARBgrad4: "linear-gradient(to right, #25adea 0%, #a151ff 100%)",
    // rest of app
    bgGlobal: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#070816"
      //? "#1E2131"
      : "#fdfbfb",
      //: "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
    textColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "white"
      : "black",
    textColor2: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "grey"
      : "grey",
    textColor3: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "lightblue"
      : "black",
    textColor4: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "lightgrey"
      : "black",
    iconColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#25adea"
      : "black",
    colorAccent: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#25adea"
      : "#3C84E4",
    bgButton1: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "linear-gradient(to right, #25adea 0%, #a151ff 100%)"
      : "#3C84E4",//"black",
    bgBox1: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#3b436b"
      : "#DCDCDC",
    bgBox2: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#3b436b"
      : "#EEEEEE",
    borderColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#353535"
      : "lightgrey",
    navBarBgColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "linear-gradient(to right, #25adea 0%, #8A53CD 100%)"
      : "#1E2131",
    mobileNavBackground: (darkMode !== null && darkMode !== undefined && darkMode)
      //? "#1E2131"
      ? "#070816"
      : "#ebedee",
    themeGreen: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "lightgreen"
      : "green",
    bgBlurGlobal: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#383944"
      : "#bcbdbe",
    gradient1: "linear-gradient(to right, #25adea 0%, #a151ff 100%)",
    gradientStart: "#25adea",
    gradientEnd: "#8A53CD",
    themeRed: "red",
    themeBlue: "#1E2131",
    underdogPosition: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#25adea"
      : "#3C84E4", //"#12c2e9",
    favoredPosition: "#c471ed",
    modalBgColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#070816" //"#101010"
      : "linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)",
    modalBrColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "#353535" //"#303030"
      : "lightgrey",
    cookieAlertBgColor: (darkMode !== null && darkMode !== undefined && darkMode)
      ? "black"
      : "#ebedee",
  };
  return themeData;
}